import { render, staticRenderFns } from "./UploadTray.vue?vue&type=template&id=0d2bd869&scoped=true"
import script from "./UploadTray.vue?vue&type=script&lang=js"
export * from "./UploadTray.vue?vue&type=script&lang=js"
import style0 from "./UploadTray.vue?vue&type=style&index=0&id=0d2bd869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bd869",
  null
  
)

export default component.exports